import { JiraServiceManagementIcon } from '@atlaskit/logo';

import { DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-comment-entity-ati';
import { DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI } from '../../../types/default-cloud-graph-project-entity-ati';
import { DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI } from '../../../types/default-cloud-graph-space-entity-ati';
import { DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI } from '../../../types/default-cloud-graph-work-item-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo, RovoLogoFromLogo } from '../../icons';
import { JiraServiceManagementSearchResultIcon } from '../../icons/jira/jira-service-management-search-result-icon';
import { ProductResourceTypes3P } from '../types';

export const jsmDCConfig: ThirdPartyConfig = {
	displayName: 'JSM Data Center',
	id: 'jsm-dc',
	resourceType: ProductResourceTypes3P.JsmDC,
	icon: RovoLogoFromLogo(JiraServiceManagementIcon, 'JSM Data Center'),
	searchResultIcon: get3PLogo(JiraServiceManagementSearchResultIcon, 'JSM Data Center', 'large'),
	integrationAri: 'ari:cloud:platform::integration/jira-dc',
	containerTypes: ['service_desk'],
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Project,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.ServiceDesk],
			},
		],
		[
			TypeFilterValueKey.Issue,
			{
				entities3P: [
					...DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
					...DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI,
				],
				subTypes3P: [NounSubtypeKey.Issue],
			},
		],
		[
			TypeFilterValueKey.Comment,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated', 'project', 'assignee'],
	requiresOauth: true,
	isEnabled: () => true,
	fanOutConnectorSources: true,
	displayWorkspaceNameAsProductName: true,
	getFiltersForSelectedDatasources: (datasource, existingFilters) => ({
		...existingFilters,
		thirdPartyProduct: {
			...existingFilters?.thirdPartyProduct,
			integrationId: datasource?.integrationAri,
			providerId: datasource?.providerId,
		},
	}),
};
